const normalizeCustomFieldValue = (value: string | null | undefined): string | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : undefined;
};

export const sanitizeCustomFields = (
  customFields: Record<string, string | null | undefined> | null | undefined
): Record<string, string> | undefined => {
  if (!customFields) {
    return undefined;
  }

  const sanitizedCustomFields: Record<string, string> = {};
  Object.entries(customFields).forEach(([key, value]) => {
    const sanitizedValue = normalizeCustomFieldValue(value);
    if (sanitizedValue) {
      sanitizedCustomFields[key] = sanitizedValue;
    }
  });

  return Object.entries(sanitizedCustomFields).length > 0 ? sanitizedCustomFields : undefined;
};
